module.exports = __webpack_public_path__ + "static/media/spin-mobile.ca19216b.svg";